import Log from "./Log.js";
import LogHistory from "./LogHistory.js";
import LogProxy from "./LogProxy.js";
export var logProxy = new LogProxy();
export var logHistory = new LogHistory(logProxy);
export function logInit() {
  var logLevel = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 2;
  var enableProxy = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  Log.setLogLevel(logLevel);
  if (enableProxy) {
    logProxy.enable();
    logHistory.enable();
  }
  if (window != null) {
    // Expose the default logger so that log level can be changed dynamically
    window.DHLog = Log;
    window.DHLogProxy = logProxy;
    window.DHLogHistory = logHistory;
  }
}
export default logInit;
//# sourceMappingURL=LogInit.js.map